import Vue from 'vue'
import Vuex from 'vuex'
import login from './login'

Vue.use(Vuex)
var domain = process.env.MODE == 'pro' ? 'laozicloud.com' : 'laozicloud.net'
if(!location.origin.includes('laozicloud')){
    domain = ''
}

export default new Vuex.Store({
    state: {
    },
    mutations: {
       
    },
    actions: {
    },
    modules: {
        login,
       
    },
})
